import { gql } from '@apollo/client';

export const UpdateFontsStore = gql`
mutation UpdateFontsStore($idStore: ID!, $content: contentFonts!) {
  updateFontsStore(idStore: $idStore, content: $content) {
    status
  }
}
`;